import script from "./AccessLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessLogs.vue?vue&type=script&setup=true&lang=js"

import "./AccessLogs.vue?vue&type=style&index=0&id=6c12d83c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c12d83c"]])

export default __exports__